import { isFuture, isPast, isToday } from 'date-fns';

import { PayMonthOverviewViewModel } from '../../types';

export const isReportingPeriodOpen = (reportingPeriod: PayMonthOverviewViewModel) => {
  const periodToDate = new Date(reportingPeriod.periodToDate);
  const periodFromDate = new Date(reportingPeriod.periodFromDate);
  return (isFuture(periodToDate) || isToday(periodToDate)) && (isPast(periodFromDate) || isToday(periodFromDate));
};
